import React, {useMemo} from "react";
import "./SettingsView.css";
import Form from "react-bootstrap/Form";
import {Field, useFormikContext} from "formik";
import {WalkMap} from "./types";
import {getCumulativeDistancesKM} from "@walkways/shared";
import ImageField from "./ImageField";

const SettingsView = () => {
  const {values: walkMap} = useFormikContext<WalkMap>();

  const totalDistancePX = useMemo<number>(() => {
    let distance = 0;

    if (walkMap.points.length < 2) {
      return distance;
    }

    for (let i = 1; i < walkMap.points.length; i++) {
      const point1 = walkMap.points[i - 1];
      const point2 = walkMap.points[i];

      distance += Math.sqrt(
        Math.pow(point1.x - point2.x, 2) + Math.pow(point1.y - point2.y, 2),
      );
    }

    return distance;
  }, [walkMap.points]);

  const totalDistanceKM = useMemo<number>(() => {
    const cumulativeDistancesKM = getCumulativeDistancesKM(walkMap);
    return cumulativeDistancesKM[cumulativeDistancesKM.length - 1] ?? 0;
  }, [walkMap]);

  return (
    <div className="SettingsView">
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>ID</Form.Label>
          <Field
            className="form-control"
            type="text"
            name="id"
            disabled={walkMap.saved}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Name</Form.Label>
          <Field className="form-control" type="text" name="name" />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Map Image: </Form.Label>
          <ImageField />
        </Form.Group>
        <Form.Group className="mb-3">
          <div>Total Pixels: {Math.round(totalDistancePX)}</div>
          <div>Total KM: {Math.round(totalDistanceKM)}</div>
          <Form.Label>Adjust pixel to km scale</Form.Label>
          <Field className="form-control" min={0} type="number" name="pxToKM" />
        </Form.Group>
      </Form>
    </div>
  );
};

export default SettingsView;
